import axios from "axios";
import config from "../../../settings/config";
import { handleError } from "../../../network/servicErrorHandling";

async function managersList(uid) {
  return Promise.resolve().then((v) =>
    axios
      .get(`${config.baseUrl}v1/shops/${uid}/admins`)
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        handleError(err);
      })
  );
}

async function addManager(uid, params) {
  return Promise.resolve().then((v) =>
    axios
      .post(`${config.baseUrl}v1/shops/${uid}/admins`, params)
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        handleError(err);
        return err;
      })
  );
}

async function editManager(uid, id, params) {
  return Promise.resolve().then((v) =>
    axios
      .put(`${config.baseUrl}v1/shops/${uid}/admins/${id}`, params)
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        handleError(err);
      })
  );
}

async function ManagerDetail(uid, id) {
  return Promise.resolve().then((v) =>
    axios
      .get(`${config.baseUrl}v1/shops/${uid}/admins/${id}`)
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        handleError(err);
      })
  );
}

export { managersList, addManager, ManagerDetail, editManager };
